/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Loader, Icon } from '@insticator/insticator-ui'; // iui-material
// utils
import { isContentValid } from 'utils/embedcontentvalidation';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/steps/stepindicator/step/step_styles';



/* ========== ~~~~~~~~~~ STEP INDICATOR : STEP ~~~~~~~~~~ ========== */
const Step = (props) => {
	const handleClick = (e) => {
		e.preventDefault();
		props.currStepName === 'customize' ? moveWithValidation(props.data.name) : props.moveToPage(props.data.name);
	};
	const moveWithValidation = (target) => {
        if(isContentValid(props.selectedContent)) {
            props.moveToPage(target)
        } else {
            props.invalidateSelectedContent();
            props.sendMessage('There are required fields you must fill out before continuing.');
        }
    };
    const isActive = props.data.name === props.currentStepPage ? 'active' : 'inactive';
    return(
    	<div className={`step ${props.classes.step} ${props.data.name} ${isActive} isSavingData-${props.isSavingData} changeDetected-${props.changeDetected}`} onClick={handleClick}>
            <div className={`desc`}>
                <Icon name={`edit`} />
                <Loader />
    			<div className={`text`}>{props.data.title}</div>
            </div>
		</div>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Step);
